import React from 'react';

export default function Active() {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 12.8C0 8.31958 0 6.07937 0.871948 4.36808C1.63893 2.86278 2.86278 1.63893 4.36808 0.871948C6.07937 0 8.31958 0 12.8 0H19.2C23.6804 0 25.9206 0 27.6319 0.871948C29.1372 1.63893 30.3611 2.86278 31.1281 4.36808C32 6.07937 32 8.31958 32 12.8V19.2C32 23.6804 32 25.9206 31.1281 27.6319C30.3611 29.1372 29.1372 30.3611 27.6319 31.1281C25.9206 32 23.6804 32 19.2 32H12.8C8.31958 32 6.07937 32 4.36808 31.1281C2.86278 30.3611 1.63893 29.1372 0.871948 27.6319C0 25.9206 0 23.6804 0 19.2V12.8Z'
        fill='url(#paint0_linear_5201_5299)'
      />
      <path
        d='M23.233 14.5614C22.935 14.2958 10.8009 5.48698 10.2474 5.13285L10.0771 5V7.16899C10.0771 7.87725 10.4177 8.09858 10.8435 8.45271L10.9286 8.49702C11.5247 8.93969 20.1676 15.1811 21.3171 16.0222C20.1676 16.8632 11.3969 23.1932 10.8435 23.5473C10.1623 23.9899 10.1197 24.2998 10.1197 24.9195V27C10.1197 27 23.0201 17.66 23.2756 17.4387C23.8717 16.996 23.9994 16.4206 23.9994 16.0664V15.8008C23.9994 15.3582 23.7439 14.9155 23.233 14.5614V14.5614Z'
        fill='url(#paint1_linear_5201_5299)'
      />
      <path
        d='M15.6626 16.9965C16.0032 16.9965 16.3438 16.8637 16.6844 16.5981C17.1101 16.2883 17.4933 16.0227 17.4933 16.0227L17.6211 15.9341L17.4933 15.8456C17.4507 15.8013 11.7882 11.7289 11.1921 11.3306C10.9366 11.1092 10.596 11.065 10.3831 11.1977C10.1703 11.3305 10 11.5518 10 11.906V13.2782L10.0426 13.3225C10.0853 13.3669 13.9596 16.1555 14.7259 16.6867C15.0665 16.908 15.3646 16.9966 15.6626 16.9966L15.6626 16.9965Z'
        fill='url(#paint2_linear_5201_5299)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_5201_5299'
          x1='16'
          y1='0'
          x2='16'
          y2='32'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#1589FA' />
          <stop offset='1' stop-color='#004DFF' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_5201_5299'
          x1='9.96958'
          y1='0.479724'
          x2='27.0734'
          y2='16.3447'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' />
          <stop offset='1' stop-color='white' stop-opacity='0.65' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_5201_5299'
          x1='9.94112'
          y1='9.91623'
          x2='13.7137'
          y2='17.0911'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='white' />
          <stop offset='1' stop-color='white' stop-opacity='0.65' />
        </linearGradient>
      </defs>
    </svg>
  );
}
